import { useMemo } from 'react';

const EventResponsesCounter = ({results}) => {
    // Count unique questions 
      const uniqueQuestionsAnswered = useMemo(() => {
        if (!Array.isArray(results) || results.length === 0) return 0;

        const uniqueSet = new Set();

        for (const r of results) {
          uniqueSet.add(r.FieldID);
          
        }
    
        return uniqueSet.size;
      }, [results]);

      return <>{uniqueQuestionsAnswered}</>;
}

export default EventResponsesCounter